import React from 'react';
import {Route} from 'react-router-dom';
import {Upload, Department} from 'components/forms/sections';
import SeaServiceDays from './SeaServiceDays';
import SeaServiceBodies from './SeaServiceBodies';
import SeaServiceTotals from './SeaServiceTotals';
import Signature from './Signature';
import Owner from './Owner';
import ProgressForm from 'components/forms/ProgressForm';
// use this to pass document_
import {StatePrompt} from 'components/forms';
import getVesselInForm from '../vessel/VesselInForm';

const FormCG719S = () => {
    const node = 'cg719s';

    return (
        <ProgressForm title='CG-719S' node={node}>
            <StatePrompt />
            <Route path={`/forms/${node}/upload`}>
                <Upload documentType={node} />
            </Route>
            <Route path={`/forms/${node}/signature`}>
                <Signature />
            </Route>
            {getVesselInForm(node)}
            <Route path={`/forms/${node}/ownership`}>
                <Owner />
            </Route>
            <Route path={`/forms/${node}/department`}>
                <Department />
            </Route>
            {/* <Loop node='service'> */}
            <Route path={`/forms/${node}/sea-service-days`}>
                <SeaServiceDays />
            </Route>
            <Route path={`/forms/${node}/sea-service-totals`}>
                <SeaServiceTotals />
            </Route>
            <Route path={`/forms/${node}/sea-service-bodies`}>
                <SeaServiceBodies />
            </Route>
        </ProgressForm>
    );
};

export default FormCG719S;
